import moment from 'moment';

import AgenticCommerce from 'models/location/agentic_commerce';
import AgentActivity from 'models/agent_activity';
import changeCurrentLocation from 'actions/lib/change_current_location';
import { DATE_FORMAT } from 'models/location/reports';
import fetchReportConfigs from 'actions/reporting/fetch_report_configs';
import { findAgenticCommerceReportConfig } from 'models/reports/report_configs';
import GatewayErrorInteractiveHandler from 'scripts/application/lib/gateway_error_interactive_handler';
import SetAndLogActivity from 'actions/agent_activity/set_and_log_activity';

export default class OpenAgenticCommerce {
  constructor(context) {
    this.context = context;
  }

  run({ timezone } = {}) {
    const appFeatures = this.context.stores.appFeatures.get();
    if (!appFeatures.isEnabled('reports:read')) {
      this.context.router.navigateHome();
      return;
    }

    const location = AgenticCommerce.create({ timezone });
    if (appFeatures.isEnabled('enableBeacon')) {
      fetchReportConfigs(this.context)
        .then(() => this.requestReport(location))
        .catch(err => this.handleErrors(err));
    }

    changeCurrentLocation(this.context, location);
    this.context.executeAction(SetAndLogActivity, { type: AgentActivity.Type.REPORTS });
  }

  requestReport(location) {
    const config = findAgenticCommerceReportConfig(this.context.stores.reportConfigs.get().configs);
    if (!config) {
      return;
    }

    // The dashboard has its own Period filter, but the endpoint needs dates to build the report descriptor.
    this.context.stores.embedTokensReport.setLoading();
    this.context.gateways.embedTokensReport.add(
      { type: 'oob-report' },
      {
        metricSet: config.metricSetName,
        startAt: moment().subtract(1, 'week').format(DATE_FORMAT),
        endAt: moment().format(DATE_FORMAT),
        timezone: location.timezone,
        filters: {},
      }
    );
  }

  handleErrors(err) {
    const interactiveHandler = new GatewayErrorInteractiveHandler(this.context);
    interactiveHandler.handleCommonErrors(this.context, err);
  }
}
